<template>
  <div>
    <div class="intro-y flex items-center my-3">
      <h2 class="text-lg font-medium mr-auto">Rejection Purchase Inward</h2>
    </div>

    <div class="grid grid-cols-12 gap-4">
      <div class="intro-y col-span-12 lg:col-span-12">
        <div class="intro-y box">
          <div class="flex flex-col sm:flex-row items-center p-5 border-b border-gray-200 dark:border-dark-5">
            <h2 class="font-medium text-base mr-auto">Rough Details</h2>
          </div>

          <div class="p-5" v-if="page_data.purchase">
            <div class="grid grid-cols-12 gap-x-5">
              <div class="col-span-12 lg:col-span-5">
                <div><label class="form-label font-bold">Purchase No. :&nbsp;</label><label class="form-label">{{ page_data.purchase.lot_no }}</label></div>
                <div class="mt-2"><label class="form-label font-bold">Kapan No. :&nbsp;</label><label class="form-label">{{ page_data.purchase.voucher_no }}</label></div>
                <div class="mt-2"><label class="form-label font-bold">Purchase PCS. :&nbsp;</label><label class="form-label">{{ page_data.purchase.pr_pcs }}</label></div>
                <div class="mt-2"><label class="form-label font-bold">Purchase WT. :&nbsp;</label><label class="form-label">{{ page_data.purchase.pr_wt }} Ct</label></div>
              </div>
            </div>
          </div>

          <div class="text-center p-5" v-else>Purchase Details Not Found</div>
        </div>

        <!-- BEGIN: Input -->
        <div class="intro-y box p-5 mt-5">
            <div id="input" class="">
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-6 sm:col-span-4 md:col-span-3">
                        <div>
                            <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Select Rejection Type</label></div>
                            <TomSelect v-model="purchase.rejection_type" @change="onChangeRejectionType" :options="{
                          placeholder: 'Select Rejection Type',
                        }" class="w-full">
                                    <option v-for="(rejectionType,index) in rejectionTypes" :key="index" :value="rejectionType.key">{{ rejectionType.value }}</option>
                                </TomSelect>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-4 md:col-span-3">
                        <div>
                            <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Select Rejection</label></div>
                            <div v-if="purchase.rejection_type == 1">

                              <TomSelect v-model="purchase.rejection_id" disabled :options="{
                            placeholder: 'Select Rejection Type',
                          }" class="w-full">
                                      <option value="0">Select Rejection</option>
                                      <option v-for="(assortment,index) in screenData.assortments" :key="index" :value="assortment.id">{{ assortment.assortment_name }}</option>
                                  </TomSelect>
                            </div>
                                <div v-if="purchase.rejection_type == 2">

                                  <TomSelect v-model="purchase.rejection_id" :options="{
                                placeholder: 'Select Rejection Type',
                              }" class="w-full">
                                          <option value="0">Select Rejection</option>
                                          <option v-for="(assortment,index) in screenData.assortments" :key="index" :value="assortment.id">{{ assortment.assortment_name }}</option>
                                      </TomSelect>
                                </div>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-4 md:col-span-3">
                        <div>
                            <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Total Pieces</label></div>
                            <div>
                                <div class="input-group mt-2 sm:mt-0">
                                    <input type="text" v-model="purchase.total_pieces" disabled class="form-control" placeholder="Total Pieces" aria-describedby="input-group-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-6 sm:col-span-4 md:col-span-3">
                        <div>
                            <div class="flex items-top"><label for="update-profile-form-6" class="form-label py-0">Total Weight(Ct)</label></div>
                            <div>
                                <div class="input-group mt-2 sm:mt-0">
                                    <input type="text" v-model="purchase.total_weight" disabled class="form-control" placeholder="Total Weight" aria-describedby="input-group-4" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- END: Input -->

        <div class="intro-y box my-5 p-5">
          <h2 class="text-lg font-medium mr-auto">Stock Details</h2>

          <div class="intro-y overflow-auto">

            <table class="table border-2 pt-5">
              <thead>
                <tr class="border">
                  <th>Type</th>
                  <th>Stock Weight(Ct)</th>
                  <th>Polish Weight(Ct)</th>
                  <th>Shape</th>
                  <th>Color</th>
                  <th>Purity</th>
                  <th>Cut</th>
                  <th>Polish</th>
                  <th>Symm</th>
                  <th>Fluc</th>
                  <th>TN</th>
                  <th>Discount(%)</th>
                  <th>Rapo Rate</th>
                  <th>Rate</th>
                  <th>Estimate Value</th>
                  <th>Purchase Rate</th>
                  <th></th>
                </tr>
              </thead>

              <tbody class="border">
                <tr v-for="(item, index) in purchase.packet_details" :key="index">
                  <td style="padding: 2px;">
                    <select class="form-select w-28" v-model="item.packet_type" @change="onTypeChange(item)">
                      <option value="rough">Rough</option>
                      <option value="makeable">Makeable</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <input
                      type="text"
                      v-model="item.weight"
                      class="form-control rounded-none w-28"
                      @keypress="$h.preventInvalidInput"
                      @input="onWeightInput(item)"
                      placeholder="Weight(Ct)"
                    />
                  </td>

                  <td style="padding: 2px;">
                    <input
                      type="text"
                      v-model="item.polish_weight"
                      class="form-control rounded-none w-28"
                      @keypress="$h.preventInvalidInput"
                      @input="loadPlanningValues(item)"
                      placeholder="Polish(Ct)"
                      :disabled="item.packet_type === 'rough'"
                    />
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-28" v-model="item.shape" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="s in screenData.shapes" :key="s.id" :value="s.id">{{ s.shape_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.color" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="c in screenData.colors" :key="c.id" :value="c.id">{{ c.color_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.purity" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="p in screenData.purities" :key="p.id" :value="p.id">{{ p.purity_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.cut" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="c in screenData.cuts" :key="c.id" :value="c.id">{{ c.cut_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.polish" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="p in screenData.polish" :key="p.id" :value="p.id">{{ p.polish_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.symmetry" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="s in screenData.symmetry" :key="s.id" :value="s.id">{{ s.symmetry_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.fluerocent" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="f in screenData.fluerocents" :key="f.id" :value="f.id">{{ f.fluerocent_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <select class="form-select w-24" v-model="item.tension" @change="loadPlanningValues(item)" :disabled="item.packet_type === 'rough'">
                      <option value="" disabled>Select</option>
                      <option v-for="t in screenData.tensions" :key="t.id" :value="t.id">{{ t.tension_name }}</option>
                    </select>
                  </td>

                  <td style="padding: 2px;">
                    <input type="text" v-model="item.discount" class="form-control rounded-none w-24" @keypress="$h.preventInvalidInput" @input="calculateValue(item)" :disabled="item.packet_type === 'rough'" />
                  </td>

                  <td style="padding: 2px;"><input type="text" disabled v-model="item.rap_value" class="form-control rounded-none w-24" /></td>
                  <td style="padding: 2px;"><input type="text" disabled v-model="item.value" class="form-control rounded-none w-24" /></td>
                  <td style="padding: 2px;"><input type="text" disabled v-model="item.est_majuri" class="form-control rounded-none w-32" /></td>
                  <td style="padding: 2px;"><input type="text" disabled v-model="item.owner_value" class="form-control rounded-none w-32" /></td>

                  <td style="padding: 2px;">
                    <button type="button" class="text-theme-6 flex items-center" @click="removeField(index)">
                      <Trash2Icon class="w-5 h-5 mr-1" />
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="flex justify-between mt-4">
            <button type="button" @click="AddPiece" class="btn btn-primary w-24">Add Piece</button>

            <div class="flex justify-end align-items-center">
              <router-link :to="{ name: 'purchase-view' }" class="btn btn-outline-secondary w-24 mr-1">Cancel</router-link>
              <button type="button" @click="SavePurchase" class="btn btn-primary w-24" :disabled="page_data.submit">
                Save
                <LoadingIcon v-if="page_data.submit" icon="oval" color="white" class="w-4 h-4 ml-2" />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable */
import { BASE_URL } from '@/constants/config'
import router from '@/router'
import axios from 'axios'
import { inject, onMounted, reactive } from 'vue'
import { useRoute } from 'vue-router'
import { helper as $h } from '@/utils/helper'

const route = useRoute()
const swal = inject('$swal')

const screenData = reactive({
  colors: [],
  cuts: [],
  purities: [],
  symmetry: [],
  polish: [],
  fluerocents: [],
  tensions: [],
  stones: [],
  shapes: [],
  labs: [],
  assortments: []
})

const rejectionTypes = [
  {key: 1, value: 'Rough Rejection'},
  {key: 2, value: 'LS Rejection'},
]

const page_data = reactive({
  submit: false,
  home_party: false,
  purchase: null
})

const purchase = reactive({
  ip: localStorage.getItem('sk_key'),
  kapan_id: null,
  rejection_type: '1',
  rejection_id: '0',
  total_pieces: 0,
  total_weight: 0,
  packet_details: []
})

const getRejectionTypes = () => {
  axios.post('api/master/dp_assortment', {}, { baseURL: BASE_URL, headers: authHeaders() })
    .then((res) => {
      screenData.assortments = res.data.items || []
    })
}

onMounted(() => {
  getPurchaseData()
  get_all_parameters()
  AddPiece()
  getRejectionTypes()
  calculateTotals()
})

function authHeaders() {
  return { Authorization: 'Bearer ' + localStorage.getItem('token') }
}

function get_all_parameters() {
  axios.post('api/master/get_all_parameters', {}, { baseURL: BASE_URL, headers: authHeaders() })
    .then((res) => {
      screenData.colors = res.data.color || []
      screenData.cuts = res.data.cut || []
      screenData.purities = res.data.purity || []
      screenData.polish = res.data.polish || []
      screenData.shapes = res.data.shape || []
      screenData.symmetry = res.data.symmetry || []
      screenData.fluerocents = res.data.fluerocent || []
      screenData.tensions = res.data.tension || []
      screenData.stones = res.data.stone || []
      screenData.labs = res.data.lab || []
    })
}

function getPurchaseData() {
  axios.post(
    'api/purchase/show_purchase',
    { id: route.params.id },
    { baseURL: BASE_URL, headers: authHeaders() }
  ).then((res) => {
    page_data.purchase = res.data.purchase || null
    page_data.home_party = page_data.purchase?.home_party == 1
    purchase.kapan_id = page_data.purchase.id
  }).catch(() => {
    router.push({ name: 'purchase-view' })
  })
}

function AddPiece() {
  purchase.packet_details.push({
    packet_type: 'rough',
    weight: '',
    est_majuri: '',
    polish_weight: '',
    color: '',
    purity: '',
    shape: '',
    cut: '',
    polish: '',
    symmetry: '',
    fluerocent: '',
    tension: '',
    stone: '',
    lab: '',
    certificate_no: '',
    rap_value: '',
    length: '',
    width: '',
    height: '',
    comment: '',
    owner_value: '',
    value: '',
    discount: 30,
    processing: 'normal'
  })
}

function removeField(index) {
  swal({
    title: 'Are you sure?',
    text: 'You are about to delete an item!',
    type: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Delete',
    cancelButtonText: 'Cancel',
  }).then((result) => {
    if (result.isConfirmed) {
      purchase.packet_details.splice(index, 1)
      calculateTotals()
    }
  })
}

function onTypeChange(item) {
  if (item.packet_type === 'rough') {
    item.polish_weight = ''
    item.color = ''
    item.purity = ''
    item.shape = ''
    item.cut = ''
    item.polish = ''
    item.symmetry = ''
    item.fluerocent = ''
    item.tension = ''
    item.rap_value = ''
    item.value = ''
  }
  onWeightInput(item)
}

function onWeightInput(item) {
  calculateTotals()
  if (item.packet_type === 'rough') {
    loadRoughMajuriValue(item)
  } else {
    loadPlanningValues(item)
  }
}

function calculateTotals() {
  let total = 0
  purchase.packet_details.forEach((x) => {
    total += parseFloat(x.weight || 0)
  })
  purchase.total_pieces = purchase.packet_details.length
  purchase.total_weight = parseFloat(total.toFixed(4))

  if (page_data.home_party && page_data.purchase?.per_ct_rate) {
    const rate = parseFloat(page_data.purchase.per_ct_rate || 0)
    purchase.packet_details.forEach((x) => {
      x.owner_value = x.weight ? $h.myFloat(parseFloat(x.weight) * rate) : ''
    })
  }
}

function calculateValue(plan) {
  const rap = parseFloat(plan.rap_value || 0)
  const discount = parseFloat(plan.discount || 0)
  if (!rap) return
  const value = (rap * (100 - discount)) / 100
  plan.value = $h.myFloat(value)
}

function loadPlanningValues(plan) {
  if (plan.packet_type !== 'makeable') return

  if (parseFloat(plan.polish_weight || 0) > parseFloat(plan.weight || 0)) {
    plan.polish_weight = ''
    swal('Warning!', 'Polish Weight should be less than Stock Weight!', 'warning')
    return
  }

  if (plan.polish_weight && plan.color && plan.purity && plan.shape) {
    const shapeObj = screenData.shapes.find((x) => x.id == plan.shape)
    const params = {
      color: plan.color,
      purity: plan.purity,
      shape: plan.shape,
      shape_group: shapeObj?.shape_group || '',
      polish_weight: plan.polish_weight
    }

    axios.post('api/plan/get_plan_rapo', params, { baseURL: BASE_URL, headers: authHeaders() })
      .then((res) => {
        plan.rap_value = $h.myFloat((res.data.rape_value || 0) * parseFloat(plan.polish_weight || 0))
        calculateValue(plan)
      })
  }

  if (plan.polish_weight && plan.color && plan.purity && plan.shape && plan.cut && plan.polish && plan.symmetry && plan.fluerocent && plan.tension) {
    const valueParams = {
      polish_weight: plan.polish_weight,
      color: plan.color,
      cut: plan.cut,
      purity: plan.purity,
      polish: plan.polish,
      shape: plan.shape,
      symmetry: plan.symmetry,
      fluerocent: plan.fluerocent,
      tension: plan.tension,
      stone: page_data.purchase?.stone_type,
      type: plan.packet_type,
      party_id: page_data.purchase?.party_id,
    }

    axios.post('api/plan/get_makeable_purchase_value', valueParams, { baseURL: BASE_URL, headers: authHeaders() })
      .then((res) => {
        plan.est_majuri = $h.myFloat((res.data.majuri_value || 0) * parseFloat(plan.weight || 0))
      })
  }
}

function loadRoughMajuriValue(plan) {
  if (!plan.weight) return
  const valueParams = {
    weight: plan.weight,
    stone: page_data.purchase?.stone_type,
    type: plan.packet_type,
    party_id: page_data.purchase?.party_id,
  }

  axios.post('api/plan/get_rough_purchase_value', valueParams, { baseURL: BASE_URL, headers: authHeaders() })
    .then((res) => {
      plan.est_majuri = $h.myFloat((res.data.majuri_value || 0) * parseFloat(plan.weight || 0))
    })
}

function validateRows() {
  if (!purchase.packet_details.length) return 'Add at least 1 piece.'

  for (const row of purchase.packet_details) {
    if (!row.weight) return 'Stock Weight is required for all rows.'

    if (row.packet_type === 'makeable') {
      if (!row.polish_weight || !row.shape || !row.color || !row.purity || !row.cut || !row.polish || !row.symmetry || !row.fluerocent || !row.tension) {
        return 'All makeable fields are required.'
      }
    }
  }
  return ''
}

function SavePurchase() {

  swal.fire({
    title: 'Are you sure?',
    text: "You won't be able to rejection stock!",
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Yes, Save it!'
  }).then((result) => {
    if (result.isConfirmed) {
      if (page_data.submit) return

      calculateTotals()
      const err = validateRows()
      if (err) {
        swal('Warning!', err, 'warning')
        return
      }

      page_data.submit = true

      const payload = {
        kapan_id: Number(purchase.kapan_id),
        rejection_type: Number(purchase.rejection_type),
        rejection_id: ((purchase.rejection_id == '0' || purchase.rejection_type == '1') ? null : Number(purchase.rejection_id)),
        total_pieces: purchase.total_pieces,
        total_weight: purchase.total_weight,
        data: purchase.packet_details.map((x) => ({
          packet_type: x.packet_type,
          weight: x.weight,
          polish_weight: x.polish_weight || null,
          shape: x.shape || null,
          color: x.color || null,
          purity: x.purity || null,
          cut: x.cut || null,
          polish: x.polish || null,
          symmetry: x.symmetry || null,
          fluerocent: x.fluerocent || null,
          tension: x.tension || null,
          discount: x.discount || null,
          rap_value: x.rap_value || null,
          value: x.value || null,
          est_majuri: x.est_majuri || null,
          owner_value: x.owner_value || null,
          length: x.length || null,
          width: x.width || null,
          height: x.height || null,
          comment: x.comment || null,
          processing: x.processing || 'normal',
        }))
      }

      axios.post('/api/purchase/rejection-to-packet-create', payload, { baseURL: BASE_URL, headers: authHeaders() })
        .then((res) => {
          page_data.submit = false
          if (res.data.success === false) {
            swal('Warning!', res.data.message || 'Validation failed.', 'warning')
            return
          }
          router.push('/purchase/rough/' + route.params.id)
        })
        .catch((err) => {
          page_data.submit = false
          swal('Warning!', err?.response?.data?.message || 'Something went wrong.', 'warning')
        })
    }
  }).catch((err) => {

  })

}

const onChangeRejectionType = () => {
  if (purchase.rejection_type == '1') {
    purchase.rejection_id = '0'
  }
}
</script>
